import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { TeamMemberType } from '@/types/dashboardTypes';

export const getTeamApi = (): Promise<ApiResponseType<{ results: TeamMemberType[] }>> => {
  return authApiService.GET('/dashboard/team/');
};
